export default __webpack_public_path__ + "static/comment-c0a8498f2e092ae42e2fa71c98053fee.jpg";